export const SHOW_TEMPORAL_SERVICE_INTERRUPTION_POP_UP: boolean = true
;
